import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from '../../../actions/helpers'
import {AddressUpdateAction} from './types'

export const getShippingAddress = fsaPayloadByKeys(AddressUpdateAction.GET_SHIPPING_ADDRESS, [
  'orderId',
])

export const getShippingAddressPending = fsa(AddressUpdateAction.GET_SHIPPING_ADDRESS_PENDING)

export const getShippingAddressSuccess = fsaPayload(
  AddressUpdateAction.GET_SHIPPING_ADDRESS_SUCCESS,
)

export const getShippingAddressFailure = fsaError(AddressUpdateAction.GET_SHIPPING_ADDRESS_FAILURE)

export const saveShippingAddress = fsaPayload(AddressUpdateAction.SAVE_SHIPPING_ADDRESS)

export const saveShippingAddressPending = fsa(AddressUpdateAction.SAVE_SHIPPING_ADDRESS_PENDING)

export const saveShippingAddressFailure = fsaError(
  AddressUpdateAction.SAVE_SHIPPING_ADDRESS_FAILURE,
)

export const saveShippingAddressSuccess = fsaPayload(
  AddressUpdateAction.SAVE_SHIPPING_ADDRESS_SUCCESS,
)
